// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"36deb8a1","374":"8d13b97d","447":"a4e96632","507":"bf623bb3","801":"5b5747a4","849":"d6a91afe","962":"1eda5bbc","980":"58381292"}[chunkId] + ".chunk.js";
};